import icons from '../iconsBundle';
import { getGlobal } from './getGlobal';
export function registerIconsBundle() {
    Object.assign(getGlobal(), {
        vocadsIconsRegistered: true,
        vocadsIcons: icons,
    });
}
